const TemplateSymbolsCountFields = {
    Telegram: '1000',
    PushNotification: '4000',
    Viber: '1000',
    Hoory: '1000',
    WhatsAppProvider: '1000', // TODO: check with backend
};

const ViberTemplateConfig = {
    DefaultValidityPeriodInMinutes: '480',
    MaxValidityPeriodInMinutes: '1440',
    MinValidityPeriodInMinutes: '10',
};

const HooryTemplateConfig = {
    DefaultValidityPeriodInMinutes: '480',
    MaxValidityPeriodInMinutes: '1440',
    MinValidityPeriodInMinutes: '10',
};

const WhatsAppProviderTemplateConfig = {
    MaxValidityPeriodInMinutes: '1440', // TODO: check with backend
    MinValidityPeriodInMinutes: '10', // TODO: check with backend
};

export { TemplateSymbolsCountFields, ViberTemplateConfig, HooryTemplateConfig, WhatsAppProviderTemplateConfig };
